import React from 'react';
import { ChevronDown, ChevronRight, Building2, User, HelpCircle, MapPin } from 'lucide-react';
import { cn } from '../../../utils/cn';

/**
 * JobSiteGroupHeader
 *
 * Top-level collapsible header for a Job Site group.
 * Displays job site icon, name/address, and job counts.
 *
 * Note: Contractors see Job Sites only, not Clients.
 */
const JobSiteGroupHeader = ({
  jobSite,
  jobCount,
  instanceCount,
  isExpanded,
  onToggle,
  colorScheme,
  isFirst = false
}) => {
  const getJobSiteIcon = () => {
    switch (jobSite?.type) {
      case 'job_site':
        return <MapPin size={18} className="text-text-secondary" />;
      case 'company':
        return <Building2 size={18} className="text-text-secondary" />;
      case 'individual':
        return <User size={18} className="text-text-secondary" />;
      case 'unassigned':
        return <HelpCircle size={18} className="text-text-secondary" />;
      default:
        return <MapPin size={18} className="text-text-secondary" />;
    }
  };

  return (
    <>
      {/* Double green line separator between job site groups (not for first) */}
      {!isFirst && (
        <div className="flex flex-col">
          <div className="h-[2px] bg-accent" />
          <div className="h-[1px] bg-accent/50" />
        </div>
      )}

      <div
        onClick={onToggle}
        className={cn(
          'px-3 py-2.5 cursor-pointer transition-colors',
          'hover:brightness-95 dark:hover:brightness-110',
          colorScheme?.jobSite || colorScheme?.receiver
        )}
      >
        <div className="flex items-center gap-2">
          {/* Chevron */}
          <button className="text-text-secondary hover:text-text-primary flex-shrink-0">
            {isExpanded ? (
              <ChevronDown size={16} />
            ) : (
              <ChevronRight size={16} />
            )}
          </button>

          {/* Icon */}
          <div className="flex-shrink-0">
            {getJobSiteIcon()}
          </div>

          {/* Job Site Name/Address */}
          <span className="text-text-primary font-medium text-sm truncate flex-1">
            {jobSite?.name || jobSite?.address || 'Unknown Location'}
          </span>

          {/* Count Badge - simplified */}
          <span className="px-2 py-0.5 bg-border text-text-secondary text-xs rounded-full flex-shrink-0">
            {jobCount} {jobCount === 1 ? 'job' : 'jobs'}
          </span>
        </div>
      </div>
    </>
  );
};

export default JobSiteGroupHeader;
